import React from 'react';

import colors from '@totem/styles/colors';
import fonts from '@totem/styles/fonts';

type SizeOptions = 'small' | 'large' | 'massive';

const styles = {
  information: {
    fontSize: fonts.fontSm,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.badges.information.background,
    color: colors.badges.information.foreground,
  },
  icon: {
    color: colors.neutral.dim,
  },
  small: {
    height: '1.75rem',
    //width: '1.75rem',
    display: 'inline-block',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    whiteSpace: 'nowrap',
  },
  large: {
    height: '3.2rem',
    //width: '3.2rem',
    display: 'inline-block',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    whiteSpace: 'nowrap',
  },
  massive: {
    height: '13rem',
    //width: '13rem',
    display: 'inline-block',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    whiteSpace: 'nowrap',
    fontSize: '7rem',
  },
};

type Props = {
  count: number;
  style?: React.CSSProperties;
  size?: SizeOptions;
  tooltip?: string;
};

const InfoBadge = ({ count, size, tooltip, style }: Props) => {
  return (
    <div
      // @ts-ignore
      style={{
        ...styles.information,
        ...(styles[size] ? styles[size] : styles.small),
        ...style,
        ...(tooltip && {
          cursor: 'pointer',
        }),
      }}
    >
      {count}
    </div>
  );
};

export default InfoBadge;
